module.exports = __webpack_public_path__ + "img/Within-Reason.4ca1370b.jpg";